import { jsx, jsxs } from "react/jsx-runtime";
const LaptopPremium = ({ className, color: colorProp = '#181B32', secondaryColor: secondaryColorProp = 'var(--color-primary-light-400)', size = 32, ignoreColor })=>{
    const color = ignoreColor ? void 0 : colorProp;
    const secondaryColor = ignoreColor ? void 0 : secondaryColorProp;
    return /*#__PURE__*/ jsxs("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M45 44H3C1.35 44 0 42.65 0 41V36H48V41C48 42.65 46.65 44 45 44ZM2 38V41C2 41.55 2.45 42 3 42H45C45.55 42 46 41.55 46 41V38H2Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M45 37H43V8C43 7.45 42.55 7 42 7H6C5.45 7 5 7.45 5 8V37H3V8C3 6.35 4.35 5 6 5H42C43.65 5 45 6.35 45 8V37Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M42 40H40V43H42V40Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M38 40H36V43H38V40Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M34 40H32V43H34V40Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M32.7625 33.8625L24.5125 28.8375L16.2625 33.8625L18.5125 24.625L11 18.5375L20.8875 17.5375L24.525 9L28.1625 17.5375L38.05 18.5375L30.5125 24.625L32.7625 33.8625ZM24.5125 26.4875L29.675 29.625L28.275 23.8625L33 20.0375L26.775 19.4L24.525 14.1L22.275 19.4L16.05 20.0375L20.775 23.8625L19.375 29.625L24.5125 26.4875Z",
                fill: secondaryColor
            })
        ]
    });
};
const pictograms_LaptopPremium = LaptopPremium;
export default pictograms_LaptopPremium;
